<template>
  <div class="group">
    <FormLabel v-if="label" :text="label" :for-id="inputId" :text-color-class="labelColorClass" :extra-class="labelClass" />
    <div class="relative">
      <input
        :id="inputId"
        :value="modelValue"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        class="w-full bg-white border rounded-2xl px-4 py-3 text-sm font-medium focus:outline-none focus:ring-4 shadow-sm transition-all"
        :class="inputClass"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <div v-if="rightIconClass" class="absolute right-3 top-3 pointer-events-none" :class="rightIconColorClass">
        <i :class="rightIconClass" class="text-lg block"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormLabel from '../Label.vue';

defineProps({
  modelValue: { type: [String, Number], default: '' },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  type: { type: String, default: 'text' },
  inputId: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  inputClass: {
    type: String,
    default: 'border-[#1c4848]/10 text-[#1c4848] focus:border-[#1c4848]/30 focus:ring-[#1c4848]/5 placeholder-[#1c4848]/20'
  },
  labelColorClass: { type: String, default: 'text-[#1c4848]/60' },
  labelClass: { type: String, default: '' },
  rightIconClass: { type: String, default: '' },
  rightIconColorClass: { type: String, default: 'text-[#1c4848]/20' }
});

defineEmits(['update:modelValue']);
</script>
